import Model from './model.js';
import Company from './company.js';
import MtdLimits from 'newCollections/mtd-limits.js';

// TODO We don't have the time to go down the rabbit hole of getting rid
// of these "consts" and constValue, but we have to eventually.
const constValues = (re) => {
    return _.map(_.filter(_.keys(consts), function(constName) {
        return re.test(constName);
    }), function(constName) {
        return consts[constName];
    });
};
export const consts = {
    TYPE_BASE:         'base',
    TYPE_ADDITION:     'addition',
    TYPE_BONUS:        'bonus',
    TYPE_DEDUCTION:    'deduction',
    TYPE_BENEFIT:      'benefit',
    TYPE_CP38:         'cp38',
    TYPE_UNPAID_LEAVE: 'unpaid_leave',
    TYPE_MTD:          'mtd',
    TYPE_SOCSO:        'socso',
    TYPE_EPF:          'epf',
    TYPE_ZAKAT:        'zakat',
    TYPE_OVERTIME:     'overtime',
    TYPE_EIS:          'eis',
    TYPE_HRDF:         'hrdf',

    CATEGORY_REMUNERATION: 0,
    CATEGORY_ALLOWANCES:   1,
    CATEGORY_BIKS:         2,
    CATEGORY_DEDUCTIONS:   3,
    CATEGORY_PERQUISITES:  4
};

export default class PayrollItem extends Model {
    urlRoot() { return '/PayrollItems'; }

    constructor() {
        super(...arguments);
        this.categories = [
            {name: 'Remuneration', text: ''},
            {name: 'Allowances', text: ''},
            {name: 'Benefits-in-Kind', text: ''},
            {name: 'Deductions', text: ''},
            {name: 'Other Perquisites', text: ''}
        ];
    }

    constraints() {
        return {
            name: {presence: true},
            type: {
                presence: true,
                inclusion: constValues(/^TYPE_/)
            },
            category: {
                presence: true,
                inclusion: constValues(/^CATEGORY_/)
            },
            // We are deprecating this attribute, sometimes it might still
            // appear so in those cases we need to validate at least that
            // its a number.
            mtdLimit: {numericality: {greaterThanOrEqualTo: 0}},
            overtimeFactor: function(value, attrs) {
                if (attrs.type !== 'overtime') {
                    return null;
                }

                return {
                    presence: true,
                    numericality: {
                        greaterThanOrEqualTo: 1.0,
                        message: '^Rate must be at least 1.0'
                    }
                };
            },
            eaFields: function() {
                return {
                    presence: {message: `^You need to select an EA field`},
                    length: {
                        minimum: 1,
                        maximum: 2,
                        message: `^Please select an EA field or ` +
                            `choose 'None'`
                    }
                };
            }
        };
    }

    defaults() {
        return {
            companyId: null,
            isUnit: false,
            isGross: false,
            isNet: false,
            allowRecurrency: false,
            affectsMtd: false,
            affectsEpf: false,
            affectsSocso: false,
            mtdLimit: 0,
            additionalInfoClass: null,
            popularity: 0,
            hiddenAt: null,
            overtimeFactor: 0,
            afterWorkingHours: false,
            nonWorkingDays: false,
            holidays: false
        };
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.mtdLimits = new MtdLimits(null, {payrollItem: this});
        this.mtdLimit = false;
        this.on('change:mtdLimit', this.updateMtdLimit, this);
        return this;
    }

    // We are deprecating this attribute, sometimes it might still appear
    // so in those cases we need to validate at least that its a number.
    validate(attributes) {
        let validationError = super.validate(...arguments);

        if (
            this.get('mtdLimit') === 0 &&
            attributes.mtdLimit !== this.get('mtdLimit') &&
            (validationError && validationError.eaFields)
        ) {
            delete validationError.eaFields;

            if (_.isEmpty(validationError)) {
                return false;
            }
        }

        return validationError;
    }

    getCompany() {
        if (!this.get('companyId')) {
            return Promise.resolve(null);
        }

        const company = new Company({objectId: this.get('companyId')});
        return company.fetch();
    }

    // This three methods are UI related. If I'm not mistaken they are used
    // in the payroll item selector to determine which item has been clicked on
    // or not. TODO move elsewhere
    toggleSelect() {
        this.selected = !this.selected;
        this.trigger(!!this.selected ? 'select' : 'unselect', this);
    }
    isSelected() {
        return !!this.selected;
    }
    isSelectableAsDefault() {
        return (
            this.get('type') === consts.TYPE_ADDITION ||
            this.get('type') === consts.TYPE_BONUS ||
            this.get('type') === consts.TYPE_DEDUCTION ||
            this.get('type') === consts.TYPE_BENEFIT ||
            this.get('type') === consts.TYPE_ZAKAT ||
            this.get('type') === consts.TYPE_CP38 ||
            this.get('type') === consts.TYPE_OVERTIME
        ) && (this.get('allowRecurrency') === true);
    }

    getTaxExemptEaField() {
        const eaField = (this.get('eaFields') || []).find(eaField => {
            return (
                typeof eaField === 'object' &&
                eaField.limit >= 0 &&
                !eaField.offset
            );
        });
        return eaField ? eaField.field : '';
    }

    getEaField() {
        const eaField = (this.get('eaFields') || []).find(eaField => {
            return (
                typeof eaField === 'string' || (
                    typeof eaField === 'object' &&
                    eaField.offset >= 0 &&
                    !eaField.limit
                )
            );
        });
        return (eaField && eaField.field) ? eaField.field : eaField;
    }

    updateMtdLimit(model, value) {
        this.mtdLimit = value;
    }

    getMtdLimit() {
        return this.mtdLimit || 0;
    }

    fetchMtdLimit(date = new Date()) {
        // if (!this.get('companyId'))
        //     return Promise.resolve(0);

        return this.mtdLimits.fetch({filter: {
            where: {
                or: [
                    {
                        validFrom: {lte: date},
                        validTo: null,
                    },
                    {
                        validFrom: {lte: date},
                        validTo: {gte: date}
                    }
                ]
            },
            order: 'primary DESC'
        }}).then(() => {
            const primaryLimit = this.mtdLimits.find(m => m.get('primary'));
            if (primaryLimit) {
                this.mtdLimit = primaryLimit.get('amount');
            }
            return this.getMtdLimit();
        });
    }

    isAddition() {
        return ['addition', 'bonus'].includes(this.get('type'));
    }

    isDeduction() {
        return this.get('type') === 'deduction';
    }

    isCustom() {
        return this.get('companyId') !== null;
    }

    // whether an item can be included in Integration (XERO, Quickbook)
    // ref: https://jibbletech.atlassian.net/browse/PPKAN-98
    // a payroll item will not be an option to mapping when either:
    //   - category: BIK,
    //   - not subject to Gross Pay nor Net Pay
    isIntegrationMappable() {
        return (
            this.get('isNet') || this.get('isGross') ||
                ['hrdf'].includes(this.get('subtype')) ||
                ['hrdf', 'socso', 'eis', 'epf', 'mtd']
                    .includes(this.get('type'))
        ) && this.get('category') !== 2;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/payroll-item.js